import { graphql } from 'react-relay';
import { QP_PAGE_SIZE_VALUE_DEFAULT } from '../constants/queryParamConstants';

const buyRespRootQuery = graphql`
    query buyRespRootQuery(
        $uriRef: String!
        $localeOrigin: String!
        $isTrade: Boolean!
        $showSeller: Boolean!
        $first: Int!
        $page: Int!
        $rootId: String!
        $fetchRegionalInfo: Boolean = false
        $userZipCode: String!
        $userCountryCode: String
        $isSbTileCarouselTest: Boolean = false
    ) {
        viewer {
            ...BuySharedLayout_viewer
            buyPage: itemSearch(
                uriRef: $uriRef
                localeOrigin: $localeOrigin
                first: $first
                page: $page
                buyPageId: $rootId
            ) {
                pageExists
                redirect {
                    location
                }
            }
            buyPagesEnabledLocales: enabledLocales(featureName: "BUY_PAGES")
        }
    }
`;

const buyRespVariables = {
    uriRef: '',
    localeOrigin: '',
    userId: '',
    isTrade: false,
    showSeller: false,
    isClient: false,
    fetchUser: false,
    first: QP_PAGE_SIZE_VALUE_DEFAULT,
    rootId: '',
    userCountryCode: '',
    isSbTileCarouselTest: false,
};

export { buyRespRootQuery, buyRespVariables };
